import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import OverlayContent from '../../../elements/overlayContent'

// Actions
import { getSparePartsForMatching, matchingSpareParts } from '../../../../actions/spareparts'

import { translation } from '../../../../utils/helpers'
import './matching.scss'
import Radio from '../../../elements/radio'
import BottomBar from '../../../elements/bottomBar'
import ConnectorLine from '../../../elements/connectorLine'
import Icon from '../../../elements/icon'
import { SparePartModuleIcons } from '../../../elements/icons'
import Grid from '../../../elements/grid'
import Divider from '../../../elements/divider'
import Label from '../../../elements/label'

class Matching extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: false,
      spareParts: [],

      lastedMatched: null,

      selectedPartLeft: null,
      selectedPartRight: null
    }

    this.renderColumn = this.renderColumn.bind(this)
    this.renderRecentMatch = this.renderRecentMatch.bind(this)
    this.renderMerged = this.renderMerged.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.usesDracar = this.usesDracar.bind(this)
    this.usesDracarCreation = this.usesDracarCreation.bind(this)
    this.handlePairing = this.handlePairing.bind(this)
    this.handlePairingReset = this.handlePairingReset.bind(this)
    this.deselect = this.deselect.bind(this)
  }

  componentDidMount () {
    this.setState({
      isLoading: true
    }, () => {
      this.props.getSparePartsForMatching({ OrderId: this.props.orderId }).then(res => {
        this.setState({ isLoading: false })
        this.handleErrors(res)
      })
    })
  }

  componentDidUpdate () {
    if (!isEqual(this.props.spareParts, this.state.spareParts)) {
      this.setState({ spareParts: this.props.spareParts })
    }
  }

  handleErrors (err) {
    if (err) {
      if (err.data) {
        if (err.data.Errors !== undefined && err.data.Errors !== null && Array.isArray(err.data.Errors) && err.data.Errors.length > 0) {
          let errors = err.data.Errors
          let errText = ''
          for (let i = 0; i < errors.length; i++) {
            let dictKey = errors[i].DictionaryKey
            errText += '<br/>' + translation(dictKey)
          }
          window.toastr.error(translation(errText), translation('216'))
          return true
        }
      } else {
        window.toastr.error(translation('960'), translation('216'))
        return true
      }
    }

    return false
  }

  usesDracar () {
    // We do not check if invoicing to Dracar is active, just that they are allowed and have it selected.
    return this.props.auth.permissions.DracarUsable
  }

  usesDracarCreation () {
    return this.props.auth.permissions.UseDracarSparePartCreation
  }

  onInputChange ({ target: { name, value } }, isDeselect = false) {
    if (!name) return

    let newValue
    if (isDeselect) {
      newValue = null
    } else {
      newValue = value
    }

    if (name === 'left') {
      this.setState({ selectedPartLeft: newValue })
    } else if (name === 'right') {
      this.setState({ selectedPartRight: newValue })
    }
  }

  deselect (e, side) {
    const selected = side === 'left' ? this.state.selectedPartLeft : this.state.selectedPartRight
    if (selected) {
      this.onInputChange(e, true)
    }
  }

  handlePairing () {
    const { selectedPartLeft, selectedPartRight, spareParts } = this.state

    let mergeFromPart = spareParts.find(s => s.OriginalSparePartNumber === selectedPartLeft || s.SparePartNumberAlias === selectedPartLeft)
    let mergeToPart = spareParts.find(s => s.OriginalSparePartNumber === selectedPartRight || s.SparePartNumberAlias === selectedPartRight)

    let matchType = 1
    // if (this.usesDracar() && this.usesDracarCreation()) matchType = 2
    if (this.usesDracar()) {
      matchType = 2
      // // For KeyLoop, switch left and right part
      // let part = mergeFromPart
      // mergeFromPart = mergeToPart
      // mergeToPart = part
    }

    const dataObj = {
      OrderId: this.props.orderId,
      MatchingType: matchType,
      MergeFrom: mergeFromPart,
      MergeTo: mergeToPart
    }

    this.props.matchingSpareParts(dataObj)
    .then(res => {
      if (!this.handleErrors(res)) {
        this.setState({
          lastedMatched: {
            left: mergeFromPart,
            right: mergeToPart
          },
          selectedPartLeft: null,
          selectedPartRight: null
        }, () => this.props.getSparePartsForMatching({ OrderId: this.props.orderId })) // Update sparepart statuses
      }
    })
    .catch(err => this.handleErrors(err))
  }

  handlePairingReset () {
    this.setState({ selectedPartLeft: null, selectedPartRight: null })
  }

  renderColumn (side, spareParts) {
    const { selectedPartLeft, selectedPartRight } = this.state

    const renderLabel = (item, partNumber) => {
      const getDescription = (item) => {
        return item.Description ? item.Description.length > 0 ? item.Description : partNumber : partNumber
      }

      partNumber = this.usesDracar() ? item.DracarPartNumber || partNumber : partNumber || ' '

      return (
        <div>
          {getDescription(item)}
          <div className='description__partnumber'>
            {partNumber}
          </div>
        </div>
      )
    }

    const renderItem = (item, index) => {
      let partNumber = item.SparePartNumberAlias || item.OriginalSparePartNumber

      let isChecked = false
      if (side === 'left') {
        isChecked = selectedPartLeft === partNumber
      }
      if (side === 'right') {
        isChecked = selectedPartRight === partNumber
      }

      return (
        <div className='parts' key={index}>
          <Radio
            size='l'
            labelText={renderLabel(item, partNumber)}
            id={`${side}-${partNumber}`}
            name={side}
            value={partNumber}
            onChange={this.onInputChange}
            onClick={(e) => this.deselect(e, side)}
            checked={isChecked}
          />
        </div>
      )
    }
    let colText = side === 'left' ? 16437 : 16438

    // if (this.usesDracar()) {
    //   // When using Dracar/KeyLoop - Left: From report, Right: Added manually
    //   colText = side === 'left' ? 16438 : 16437
    // }
    return (
      <div className='col_content'>
        <label>{translation(colText)}</label>
        {spareParts.map((item, index) => renderItem(item, index))}
      </div>
    )
  }

  renderRecentMatch () {
    const { lastedMatched } = this.state
    if (!lastedMatched) return null
    if (!lastedMatched.left || !lastedMatched.right) return null

    const renderLabel = (item, partNumber) => {
      const getDescription = (item) => {
        return item.Description ? item.Description.length > 0 ? item.Description : partNumber : partNumber
      }

      partNumber = this.usesDracar() && this.usesDracarCreation() ? item.DracarPartNumber || partNumber : partNumber || ' '

      return (
        <Label>
          {getDescription(item)}
          <div className='description__partnumber'>
            {partNumber}
          </div>
        </Label>
      )
    }

    const renderItem = (item, key) => {
      let partNumber = item.SparePartNumberAlias || item.OriginalSparePartNumber

      return (
        <Grid key={key} cols={['min-content', 1]} align='center' className='pairedItem' gap={2}>
          <span><Icon size={2} icon={SparePartModuleIcons.OK} injectSvg /></span>
          {renderLabel(item, partNumber)}
        </Grid>
      )
    }

    return [
      renderItem(lastedMatched.left, 0),
      <ConnectorLine key='connector' />,
      renderItem(lastedMatched.right, 1)
    ]
  }

  renderMerged () {
    let spareParts = this.state.spareParts.filter(x => x.IsMerged)
    if (spareParts.length === 0) return
    let automaticlyMergedParts = spareParts.filter(x => x.MergedFrom.some(y => y.MergeType === 1))
    let manuallyMergedParts = spareParts.filter(x => x.MergedFrom.some(y => y.MergeType === 2))
    const renderSparePart = (sparePart, mergeType) => {
      let lines = sparePart.MergedFrom.map((merge) => {
        if (merge.MergeType !== mergeType) return
        return {
          from: {
            partNumber: merge.PartNumber,
            OriginalSparePartNumber: merge.PartNumber,
            Description: merge.Description
          },
          to: sparePart
        }
      })
      const renderLine = (sparePartLine, index) => {
        if (sparePartLine === undefined) return
        const renderBlock = (item, index) => {
          let partNumber = item.SparePartNumberAlias || item.OriginalSparePartNumber
          let gridClass = 'pairedItem'
          if (index === 0) {
            gridClass += ' left'
          } else if (index === 1) {
            gridClass += ' right'
          }
          const renderLabel = (item, partNumber) => {
            const getDescription = (item) => {
              if (this.usesDracar() && item.DracarDescription && item.DracarDescription.length > 0) {
                return item.DracarDescription
              }
              return item.Description && item.Description.length > 0 ? item.Description : partNumber
            }
            partNumber = this.usesDracar() ? item.DracarPartNumber || partNumber : partNumber || ' '

            return (
              <Label>
                {getDescription(item)}
                <div className='description__partnumber'>
                  {partNumber}
                </div>
              </Label>
            )
          }
          return (
            <Grid key={index} cols={['min-content', 1]} align='center' className={gridClass} gap={2}>
              <span><Icon size={2} icon={SparePartModuleIcons.OK} injectSvg /></span>
              {renderLabel(item, partNumber)}
            </Grid>
          )
        }
        return (
          <div className='mergedLine'>
            {renderBlock(sparePartLine.from, 0)}
            <ConnectorLine className='middle' key='connector' />
            {renderBlock(sparePartLine.to, 1)}
          </div>
        )
      }
      return (
        lines.map(renderLine)
      )
    }

    return (
      <div className='mergedParts'>
        <Divider />
        <div className='subheader center'><label>{translation(17876)}</label></div>
        {automaticlyMergedParts.length > 0 && (
          <div className='mergedSection'>
            <div className='subheader'><label>{translation(17877)}</label></div>
            {automaticlyMergedParts.map(x => renderSparePart(x, 1))}
          </div>
        )}
        {manuallyMergedParts.length > 0 && (
          <div className='mergedSection'>
            <div className='subheader'><label>{translation(17878)}</label></div>
            {manuallyMergedParts.map(x => renderSparePart(x, 2))}
          </div>
        )}
      </div>
    )
  }

  render () {
    const { spareParts, selectedPartLeft, selectedPartRight } = this.state

    const DracarStatus = {
      Unknown: 0,
      NotMatched: 1,
      Matched: 2,
      UnusedPart: 3,
      ManuallyMatched: 4,
      MatchedViaDracar: 1001,    // It wasn't found, but later added to the DMS in Dracar
      AddedFromDracar: 2001      // It wasn't found, but later added to the DMS in Dracar
    }
    const SparepartStatus = {
      None: 0,
      Unknown: 1,
      NotInUse: 2,
      InStock: 4,
      Ordered: 8,
      Received: 16,
      Defective: 32,
      Incorrect: 64,
      BackOrder: 128
    }
    const orderedStatuses = SparepartStatus.Unknown | SparepartStatus.NotInUse | SparepartStatus.InStock | SparepartStatus.Ordered
    // const recievedStatuses = SparepartStatus.Ordered | SparepartStatus.Received | SparepartStatus.Defective | SparepartStatus.Incorrect | SparepartStatus.BackOrder

    let leftParts = []
    let rightParts = []
    const pairSelected = selectedPartLeft && selectedPartRight

    if (this.usesDracar()) {
      leftParts = spareParts.filter(x => !x.IsDeleted && (x.DracarStatus === DracarStatus.AddedFromDracar || x.DracarPartNumber && !x.OrderSparePartId || x.DracarStatus === DracarStatus.Unknown && Number(x.OrderSparePartId) === 0 && !x.RemovedFromReport))
      rightParts = spareParts.filter(x => !x.IsDeleted && (x.DracarStatus === DracarStatus.NotMatched || Number(x.OrderSparePartId) > 0 && x.DracarStatus === DracarStatus.Unknown))
      // console.log('parts (all/left/right)', spareParts, leftParts, rightParts)
    } else {
      leftParts = spareParts.filter(x => Number(x.OrderSparePartId) === 0 && !x.RemovedFromReport && (orderedStatuses & x.Status) > 0)
      rightParts = spareParts.filter(x => Number(x.OrderSparePartId) > 0 && !x.RemovedFromReport && x.Status !== SparepartStatus.None)
    }

    return (
      <div className='matchingPartsContent'>
        <OverlayContent>
          {pairSelected ? <BottomBar
            actionLabelText={translation(16588)}
            onActionClick={this.handlePairing}
            cancelLabelText={translation(1155)}
            onCancelClick={this.handlePairingReset}
            center
          /> : null}

          <div className='content'>
            { /* this.renderRecentMatch() */ }

            {this.renderColumn('left', leftParts)}
            <Divider vertical />
            {this.renderColumn('right', rightParts)}

            {this.renderMerged()}
          </div>
        </OverlayContent>
      </div>
    )
  }
}

Matching.propTypes = {
  orderId: React.PropTypes.number.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    spareParts: state.spareParts.sparePartsForMatching,
    headerInfo: state.common.headerInfo // Contains information used to determine if the shop uses DRACAR
  }
}

export default connect(mapStateToProps, {
  getSparePartsForMatching,
  matchingSpareParts
})(Matching)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/matchingSpareParts/matching/index.js